import { render, staticRenderFns } from "./SpeedGauge.vue?vue&type=template&id=36b8d16e&scoped=true"
import script from "./SpeedGauge.vue?vue&type=script&lang=js"
export * from "./SpeedGauge.vue?vue&type=script&lang=js"
import style0 from "./SpeedGauge.vue?vue&type=style&index=0&id=36b8d16e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b8d16e",
  null
  
)

export default component.exports